export const plans = [
	{
		title: 'Pick Your Favorite',
		desc: 'A special moment for every reader — find the one book that speaks to you.',
		author: 'Zuhor Books',
		date: '30 min ago',
		location: 'Zuhor Bookstore, Istanbul',
		img: '/img/111.jpg',
	  }
	  ,
	  {
		title: 'Author Spotlight',
		desc: 'Join an inspiring conversation with featured writers and thinkers. New voices, fresh ideas — arriving this Monday!',
		author: 'Belissimo Arthur',
		date: '2 days ago',
		location: 'Zuhor Bookstore, Istanbul',
		img: '/img/22.jpg',
	  },
	  {
		title: 'Mark the Moment',
		desc: 'Every page matters. Capture the wisdom, pause with purpose — and return with deeper understanding.',
		author: 'Morgan News',
		date: '5 days ago',
		location: 'Zuhor Bookstore, Florida',
		img: '/img/33.jpg',
	  }
	  ,
	  {
		title: 'Focus, then Flourish',
		desc: 'In a world full of noise, choosing the right book is the first act of clarity. Start your mindful reading journey today.',
		author: 'Zuhor Books',
		date: 'A week ago',
		location: 'Zuhor Bookstore, France',
		img: '/img/333.jpg',
	  }
	  ,
];
